import { persistReducer } from 'redux-persist'
import { Action } from '@reduxjs/toolkit'
import storage from 'redux-persist/lib/storage'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const actionTypes = {
  GetServerConfigTableData: '[GetServerConfigTableData] Action',
}

const initialServerConfigState: IServerConfigState = {
  time: ""
}

export interface IServerConfigState {
  time: string
}

export const reducer = persistReducer(
  { storage, key: 'portal-ServerConfig', whitelist:  [ ] },
  (state: IServerConfigState = initialServerConfigState, action: any) => {
    switch (action.type) {
      case actionTypes.GetServerConfigTableData: {
        const timeObj = JSON.parse(action.payload.data.time);
        const time = timeObj.value;
        return { ...state, time};
      }
      
      default:
        return state
    }
  }
)

export const actions = {
  getServerConfigTableData: (data: any) => ({ type: actionTypes.GetServerConfigTableData, payload: { data } }),
  store: () => ({ type: "def" }),
}

export function* saga() {

}
